<template>
  <el-container>
    <el-header height="auto" class="el-header">
      <home-header />
    </el-header>
    <el-main class="el-main">
      <transition name="fade">
        <router-view />
      </transition>
    </el-main>
    <el-footer height="auto" class="el-footer">
      <page-footer />
    </el-footer>
  </el-container>
</template>

<script>
import homeHeader from "../components/homeHeader";
import pageFooter from "../components/pageFooter";
import home from "@/api/home/index.js"
import req from "@/api/config/config";
import socketApi from '@/utils/socket.js'
export default {
  components: {
    homeHeader,
    pageFooter,
  },
  data(){
    return{
      
    }
  },
  methods:{
    
  },
  created() {
    
  },
};
</script>

<style lang="less" scoped>
.el-header {
  background-color: #ffffff;
}
.el-main {
  margin-bottom: 100px !important;
  min-height: 75.9vh;
}
.el-footer {
  padding: 0;
}
</style>


